import { render, staticRenderFns } from "./AllIssue.vue?vue&type=template&id=0b5a74ac&scoped=true"
import script from "./AllIssue.vue?vue&type=script&lang=js"
export * from "./AllIssue.vue?vue&type=script&lang=js"
import style0 from "./AllIssue.vue?vue&type=style&index=0&id=0b5a74ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5a74ac",
  null
  
)

export default component.exports